export default __webpack_public_path__ + "static/media/cloudUpload.2075f2cb.svg";